/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class */
import { FC, useEffect, useState } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { translate } from 'translations';
import { Button, Icon } from 'learning-panel-components';
import { NotificationTypes } from './notificationTypes';
import styles from './notification.module.scss';
import { ArrowBack } from '../../../../uiLibraryImports';

const Notification: FC<NotificationTypes> = (props: NotificationTypes) => {
    const { id, sentDate, contentHtml, className, top, refFunction, title, isActive, onSeeMoreClick, height } = props;
    const [isHover, setIsHover] = useState<boolean>(false);
    const [imageSrc, setImageSrc] = useState<string>('');

    useEffect(() => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(contentHtml, 'text/html');
        const imageElement = doc.querySelector('img');
        const imageSrc = imageElement?.getAttribute('src');
        setImageSrc(imageSrc || '');
    }, [contentHtml]);

    const getTimeCompletedElement = (date: Date) => {
        moment.locale('en', {
            relativeTime: {
                future: 'in %s',
                past: '%s ago',
                s: 'a sec ago',
                ss: '%ss ago',
                m: 'a minute ago',
                mm: '%dm ago ',
                h: '%d hour ago',
                hh: '%dh ago',
                d: 'a day ago',
                dd: '%dd ago',
                M: 'a month ago',
                MM: '%dM ago',
                y: 'a year ago',
                yy: '%dY ago'
            }
        });
        return moment(date).fromNow(true);
    };
    return (
        <div
            ref={refFunction}
            className={classNames(styles.notification, className, { [styles['active-notification']]: isActive })}
            onMouseOver={(): void => setIsHover(true)}
            onMouseLeave={(): void => {
                setIsHover(false);
            }}
            style={{ '--top': `${top}rem`, '--height': height } as any}
        >
            <div className={styles['content-wrapper']}>
                {!isHover && !isActive && <div className={styles['card-overlay']}></div>}
                <div className={styles.left}>
                    <Icon name="cbLogo" />
                </div>
                <div className={styles.middle}>
                    <div className={styles.header}>
                        <div>
                            <div>{translate('CodebashingNews')}</div>
                        </div>
                    </div>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.content} dangerouslySetInnerHTML={{ __html: contentHtml || '' }} />
                    {imageSrc && <img src={imageSrc} className={styles.image} alt="news-img" />}
                    <Button
                        type="flatFullGray"
                        text={translate('SeeMore')}
                        startIcon={<ArrowBack />}
                        onClick={() => onSeeMoreClick(id)}
                        className={styles.button}
                        lowerCase
                    />
                </div>
                <div className={styles.right}>
                    <div className={styles.date}>{getTimeCompletedElement(sentDate)}</div>
                </div>
            </div>
        </div>
    );
};

export default Notification;
